import React from "react";
import { PRODUCT_ORDER_STATUS_IDS } from "../../../../components/Utils";
import { PrimaryButtonLink } from "../../../../components/Buttons";
import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import { loadKeys } from "../../actions/keys";

const frontload = async (props) => {
  await props.getKeys();
};
const mapStateToProps = (state) => ({
  keys: state.key.catalogKeys,
  keyOrders: state.key.keyOrders,
});
const mapDispatchToProps = (dispatch) => ({
  getKeys: (...args) => dispatch(loadKeys(...args)),
});

function KeyOrderMenu({ className = "", disabled, keyOrders, keys }) {
  const found = (keyOrders || []).find(
    (item) => item.status_id !== PRODUCT_ORDER_STATUS_IDS.FINISHED,
  );
  const readOnly = disabled || (found !== null && found !== undefined);
  return (
    <div className={`cards list-menu ${className}`}>
      <PrimaryButtonLink
        id="newKeyOrderButton"
        to={`/wizard/shop/bestellung/schliessmittel/neu`}
        disabled={readOnly || keys.length === 0}
      >
        {`zum Schließmittel-Shop`}
      </PrimaryButtonLink>
    </div>
  );
}

// export default connect(mapStateToProps, mapDispatchToProps)(KeyOrderMenu);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(KeyOrderMenu),
);
